import Vue from 'vue';

function formatCurrency(value, { currency = 'KRW', locale = 'ko' } = {}) {
  if (currency === 'KRW' && locale == 'ko')
    return `${value.toLocaleString()}원`;

  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(
    value
  );
}

function formatDate(value) {
  let dateString =
    typeof value === 'string'
      ? value.replace(/\.$/, '').replace(/(\.|-)/g, '/')
      : value.toISOString();
  dateString = dateString.split('T')[0];

  const date = new Date(dateString);
  return new Intl.DateTimeFormat('ko-KR').format(date);
}

function formatDateWithoutSpace(value) {
  return formatDate(value).replace(/\s/g, '');
}

function formatDateTimeWithoutSecond(value) {
  const date = typeof value === 'string' ? new Date(value) : value;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}. ${month}. ${day}. ${hours}:${minutes}`;
}

Vue.filter('formatCurrency', (v, opts) => formatCurrency(v, opts));
Vue.filter('formatDate', v => formatDate(v, 'date'));
Vue.filter('formatDateWithoutSpace', v => formatDateWithoutSpace(v, 'date'));
Vue.filter('formatDateTimeWithoutSecond', v => formatDateTimeWithoutSecond(v));

export { formatDate, formatDateWithoutSpace, formatDateTimeWithoutSecond };
